import { TFileDB, TFileUI } from 'data/types/general.types';
import { EStorageUrls } from 'data/urls/storage.url';
import { fileConverter } from 'data/converters/general.converters';
import { authSplitApi } from '../helpers/slice.helpers';
import { COMMON_BASE_URL } from './commonApis.slice';

export const storageApi = authSplitApi('storage', ['files']).injectEndpoints({
  endpoints: (build) => ({
    uploadFile: build.mutation<TFileUI, FormData>({
      query(body) {
        return {
          url: `${COMMON_BASE_URL}/${EStorageUrls.STORAGE}/${EStorageUrls.FILES}`,
          method: 'POST',
          body,
        };
      },
      transformResponse: (data: TFileDB) => {
        return fileConverter.fromDb(data);
      },
    }),
  }),
  overrideExisting: false,
});

export const { useUploadFileMutation } = storageApi;
